import { render, staticRenderFns } from "./WebsiteArticleDetailWrap.vue?vue&type=template&id=833c5870&scoped=true&"
import script from "./WebsiteArticleDetailWrap.vue?vue&type=script&lang=js&"
export * from "./WebsiteArticleDetailWrap.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteArticleDetailWrap.vue?vue&type=style&index=0&id=833c5870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833c5870",
  null
  
)

export default component.exports